import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient'
import {
    httpGetSiarExportHistory,
    HttpGetSiarExportHistoryParams,
    HttpGetSiarExportHistoryResponse
} from '@/features/projects/siar-bulk-export/http/siarBulkExport.http'

export const useGetSiarExportHistory = (
    params: HttpGetSiarExportHistoryParams,
    options?: Omit<UseQueryOptions<HttpGetSiarExportHistoryResponse>, 'queryKey' | 'queryFn'>
) => {
    return useQuery({
        queryKey: [QUERY_KEYS.SIAR_BULK_EXPORT_HISTORY, params],
        queryFn: () => httpGetSiarExportHistory(params),
        ...options
    })
}
